/** Router errorElement. Must not depend on auth or bootstrap state. */
import { Box, Button, Stack, Typography } from '@mui/material';
import { useRouteError } from 'react-router-dom';
import { PreAppLayout } from '@/components/PreAppLayout';
import { useCopy } from '@/hooks/useCopy';
import { usePageTitle } from '@/components/page/usePageTitle';

export function RouteError() {
  const error = useRouteError();
  const { t } = useCopy();
  const heading = t('errors.generic', 'Something went wrong. Please try again.');
  usePageTitle(heading);
  if (import.meta.env.DEV) console.error('Route error:', error);

  return (
    <PreAppLayout>
      <Box
        role="alert"
        sx={{
          display: 'grid',
          placeItems: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          px: 2,
        }}
      >
        <Stack spacing={2} sx={{ alignItems: 'center' }}>
          <Typography variant="h2" component="h1">
            {heading}
          </Typography>
          <Button variant="outlined" onClick={() => window.location.assign('/')}>
            {t('common.retry', 'Retry')}
          </Button>
        </Stack>
      </Box>
    </PreAppLayout>
  );
}
